import * as yup from 'yup';

const DiscontinueRXSchema = yup.object({
  reason: yup.string().required('Required').trim().min(1, 'Required'),
  time: yup.date().required('Date is required'),
});

export { DiscontinueRXSchema };
